// extracted by mini-css-extract-plugin
export default {"services-industries-container":"ServicesIndustries_services-industries-container__6pBS3"};